var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermometerLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 41,
    viewBox: "0 0 20 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 23.0463V7.16664C16.6666 3.48477 13.6819 0.5 10 0.5C6.31813 0.5 3.33336 3.48477 3.33336 7.16664V23.0463C1.2875 24.8773 0 27.5384 0 30.5C0 36.0229 4.47719 40.5 10 40.5C15.5228 40.5 20 36.0229 20 30.5C20 27.5384 18.7125 24.8773 16.6666 23.0463ZM10 37.1666C6.31813 37.1666 3.33336 34.1819 3.33336 30.5C3.33336 28.5752 4.14906 26.7897 5.55641 25.5301L6.66672 24.5363V7.16664C6.66672 5.3257 8.15914 3.83328 10.0001 3.83328C11.841 3.83328 13.3334 5.32562 13.3334 7.16664V24.5363L14.4438 25.5301C15.8511 26.7897 16.6668 28.5752 16.6668 30.5C16.6666 34.1819 13.6819 37.1666 10 37.1666Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 24.5H11.6669V25.7846C13.6088 26.471 15 28.323 15 30.5C15 33.2614 12.7614 35.5 10 35.5C7.23858 35.5 5 33.2614 5 30.5C5 28.3229 6.39142 26.4708 8.3335 25.7844V24.5Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometerLow);
export default __webpack_public_path__ + "static/media/thermometer_low.c0a8dc2a86f150a8e02572cd8bc8c16b.svg";
export { ForwardRef as ReactComponent };